export default __webpack_public_path__ + "static/media/swiss-pro.29e8cfa7.jpg";